<template>
<router-view />
</template>

<script>
export default {
  name: 'SystemSettings',
  routeInfo: {
    label: '系统设置'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/index.vue